import { createAction } from "redux-actions";
import { urls } from "../constants/app";
import { resetError, setError } from "./errors";
import request from "./utils/request";
import { makeActionType } from "../utils";

const namespace = 'GOODS';
export const setGoodGroup = createAction(makeActionType(namespace, ['SET', 'GROUP']));
export const addGoodListGroup = createAction(makeActionType(namespace, ['ADD', 'GROUP']));
export const deleteGoodGroup = createAction(makeActionType(namespace, ['DELETE', 'GROUP']));


export function addGroup(data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'modalGroup', value: true });
        try {
            const group = await request({ method: 'post', url: urls.groupsgoods, data });
            if (group) {
                dispatch({ type: 'SET_LOADER', field: 'modalGroup', value: false });
                dispatch(addGoodListGroup(group));
                return group.id;
            }
        } catch(error) {
            dispatch(setError({ status: 506 }, 'modalGroup'));
            dispatch({ type: 'SET_LOADER', field: 'modalGroup', value: false });
            return null;
        }
    }
}

export function updateGroup(id, data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'updateGood', value: id });
        dispatch(resetError('goods'));

        try {
            const group = await request({ method: 'put', url: `${urls.groupsgoods}/${id}`, data });
            dispatch(setGoodGroup(group));
            dispatch({ type: 'SET_LOADER', field: 'updateGood', value: null });
            return group.groupId;
        } catch(error) {
            dispatch(setError(error, 'goods'));
            dispatch({ type: 'SET_LOADER', field: 'updateGood', value: null });
            return null;
        }
    }
}

export function deleteGroup(id) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'deleteGood', value: id });
        dispatch(resetError('goods'));
        try {
            await request({ method: 'delete', url: `${urls.groupsgoods}/${id}` });
            dispatch(deleteGoodGroup(id));
            dispatch({ type: 'SET_LOADER', field: 'deleteGood', value: null });
        } catch(error) {
            dispatch(setError({ status: 507 }, 'goods'));
            dispatch({ type: 'SET_LOADER', field: 'deleteGood', value: null });
        }
    }
}